import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminDashboardComponent } from './admin-dashboard.component';
import { AdminDashboardRoutingModule } from './admin-dashboard-routing.module';
import { FormsModule } from '@angular/forms';
import { CoreModule } from 'src/app/core/core.module';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'src/app/shared/shared.module';
@NgModule({
  declarations: [AdminDashboardComponent],
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    AdminDashboardRoutingModule,
    TableModule,
    SharedModule
  ]
})
export class AdminDashboardModule { }
